import ReactPixel from 'react-facebook-pixel'
import { sha256 } from 'js-sha256'
import Cookies from 'cookies-js'
import * as amplitude from '@amplitude/analytics-browser'
import { purchaseFacebookApi } from '@/helpers/facebookApi'
import { getClickId, sendPropellerPostback } from '@/helpers/propeller'

export const trackPageView = () => {
  ReactPixel.pageView()
}
export const trackViewContent = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  fbq('track', 'ViewContent')
}
export const trackCustomizeProduct = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  fbq('track', 'CustomizeProduct')
}
export const trackLead = () => {
  ReactPixel.track('Lead')
}
export const trackAmplitudeEvent = (event: string) => {
  amplitude.track(event)
}
export const trackInitCheckout = () => {
  ReactPixel.track('InitiateCheckout')
  amplitude.track('InitiateCheckout')
}
export const trackPurchase = () => {
  const isPropellerId = getClickId()
  const IP = localStorage.getItem('ip') ?? ''
  const fbc = Cookies.get('_fbc') ?? localStorage.getItem('_fbc')
  const countryCode = localStorage.getItem('countryCode')
  const activePlanString = localStorage.getItem('activePlan')
  const pixelVersion = localStorage.getItem('pixelVersion')
  const email = localStorage.getItem('userEmail') ?? ''
  const activePlan = activePlanString ? JSON.parse(activePlanString) : false
  const price = activePlan.discountedPrice

  if (price !== 0) {
    // const predictedPrice = price + 1.42 * activePlan.originalPrice
    const predictedPrice = 128.1
    const AmplitudeID = amplitude.getSessionId()
    const time = Math.floor(new Date().getTime() / 1000.0)
    const body = {
      data: [
        {
          event_name: 'Purchase',
          event_time: time,
          action_source: 'website',
          event_id: AmplitudeID,
          opt_out: false,
          user_data: {
            em: [sha256(email ?? '')],
            country: [sha256(countryCode ?? '')],
            external_id: [sha256(String(AmplitudeID))],
            fbc,
            fbp: Cookies.get('_fbp'),
            client_ip_address: IP,
            client_user_agent: window.navigator.userAgent,
          },
          custom_data: {
            currency: 'USD',
            value: price,
            predicted_ltv: predictedPrice.toFixed(2),
          },
        },
      ],
    }
    if (process.env.REACT_APP_MODE !== 'dev' && !isPropellerId) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fbq(
        'track',
        'Purchase',
        {
          currency: 'USD',
          value: price,
          predicted_ltv: predictedPrice.toFixed(2),
          external_id: AmplitudeID,
        },
        { eventID: AmplitudeID },
      )
      purchaseFacebookApi(body, email, pixelVersion ?? 'v1').then((res) => {
        if (res.error) {
          trackConversationsApiErrors(res.error, body)
        }
      })
    } else {
      sendPropellerPostback({ clickId: isPropellerId ?? '' }).then(() => {
        sendToPropellerAds()
      })
    }
    amplitude.track('Purchase')
  }
}
export const clickPurchaseButton = (method: string) => {
  amplitude.track('PurchaseButtonClick', { method })
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  fbq('track', 'AddToCart')
}
export const trackConversationsApiErrors = (e: any, payload: any) => {
  amplitude.track('conversations_api_error', { payload, error: e })
}
export const trackSecondStripeTerminal = (val: boolean) => {
  amplitude.track('secondStripeTerminal', { val })
}
export const trackEmail = (event: string, email: string) => {
  amplitude.track(event, { email })
  amplitude.setUserId(email)
}
export const trackLoadedApplePay = () => {
  amplitude.track('applepay_loaded')
}
export const trackClickApplePay = () => {
  amplitude.track('applepay_button_submited')
}
export const trackDefaultPaymentLoaded = () => {
  amplitude.track('default_payment_loaded')
}
export const trackPaymentErrors = (payment: string, e: any) => {
  amplitude.track(`payment_error:${payment}`, { error: e })
}
export const trackPayment = (payment: string, message: any) => {
  amplitude.track(`payment:${payment}`, message)
}
export const sendToPropellerAds = () => {
  amplitude.track('sendToPropellerAds')
}
